import { FC, memo } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { Skeleton } from '@chakra-ui/react';

import { TwoFactorQrCodeProps } from './types/TwoFactorQrCodeProps';

const TwoFactorQrCodeComponent: FC<TwoFactorQrCodeProps> = ({
  provisioningUri,
  size,
}) => {
  if (!provisioningUri) {
    return <Skeleton height={`${size}px`} width={`${size}px`} />;
  }

  return (
    <QRCodeSVG
      bgColor="#ffffff"
      fgColor="#000000"
      level="M"
      marginSize={2}
      size={size}
      title="Two-factor authentication QR code"
      value={provisioningUri}
    />
  );
};

export const TwoFactorQrCode = memo(TwoFactorQrCodeComponent);
